
        Component.define('map', (el, params) => {
            /**
 * O componente Each recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

let $el = $(el);
let map = null;
let markers = [];
let layerGroup = null;
let $form = $el.find('.form');
$el.find('[name="cep"]').mask('00000-000');

let searchGoogle = function(address){
    let settings = {
        "async": true,
        "url": "https://maps.googleapis.com/maps/api/geocode/json",
        'data': { address: address, key: 'AIzaSyACQUnzYpihaSqTusTFOSS8jWmxiGiArQQ' },
        "method": "GET"
    }

    if(!map){
        map = L.map('map', {
            scrollWheelZoom: false
        }).setView([-12, -46], 6);
        layerGroup = L.layerGroup().addTo(map);

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(map);

        setTimeout(function () {
            map.invalidateSize();
        }, 500);

        //map.on('focus', function () { map.scrollWheelZoom.enable(); });
        //map.on('blur', function () { map.scrollWheelZoom.disable(); });
    }

    $.ajax(settings).done(function (result) {


        layerGroup.clearLayers();

        if(result.status == 'OK'){
            let data = result.results[0].geometry.location;
            let totalStores = 30;
            let range = 10;
            let searchGeo = { lat: data.lat, lon: data.lng };

            $.ajax({
                method: "GET",
                url: storeApiUrl + 'stores',
                data: { lat: searchGeo.lat, lon: searchGeo.lon, take: totalStores, range: range },
                type: 'json'
            }).done(function (response) {
                //console.log(response);
                if (response.status) {
                    //markersLayer.clearLayers();
                    let stores = response.stores;
                    if (stores.length > 0) {
                        $el.find('.search-error-msg').remove();

                        for (let i = 0; i < stores.length; i++) {
                            let store = stores[i];
                            let lat = store.lat;
                            let lon = store.lon;
                            let name = store.name.replace(/^\d* *- */, '');
                            let image = store.network_img ? `<img src="assets/images/onde-encontrar/lojas/${store.network_img}">` : '';
                            let popUpContent = `${image}<div class="container-text"><b class='title-marker'>${name}</b><p class="marker-address">${store.address}</p></div>`;

                            var myIcon = L.icon({
                                iconUrl: 'assets/images/marker-icon-green.png?v=1',
                                iconSize: [25, 41],
                                shadowUrl: 'assets/images/marker-shadow.png',
                                shadowSize: [41, 41],
                                shadowAnchor: [12, 21]
                            });

                            var marker = L.marker([lat, lon], { icon: myIcon }).addTo(map).bindPopup(popUpContent);
                            marker.addTo(layerGroup);
                            markers.push(marker);
                        }

                        map.fitBounds(stores.reduce((acc, cur) => {
                            if (cur.lat && cur.lon) {
                                acc.push([cur.lat, cur.lon])
                            }

                            return acc;
                        }, []));

                        $('.leaflet-pane, .leaflet-control-container').css('opacity', 1);
                        $el.addClass('remove-bg');
                    }
                }
            })
            .fail(function () {
                $el.trigger('search-cep:error');
            });
        } else {
            $el.trigger('search-cep:error');
        }

    })
    .fail(function () {
        $el.trigger('search-cep:error');
    });
}


$form.validate({
    errorClass: 'error',
    errorPlacement: function (error, element) {
        return true;
    },
    rules: {
        cep : {
            required: true,
            minlength: 9,
            maxlength: 9
        }
    },
    submitHandler: function (form) {
        let cep = $el.find('[name="cep"]').val();

        if ($form.hasClass('sending')){
            return false;
        }

        if (cep) {
            $document.trigger('ga-localizar:click');

            searchGoogle(cep);
        }

        return false;
    }
});


$el.on('search-cep:error', function () {
    $form.removeClass('sending');
    errorMessage();
});

function errorMessage(){
    const error = 'Não foi possível encontrar seu cep.';
    $el.find('.search-error-msg').remove();
    $el.find('.box-form').append(`<div class="search-error-msg">${error}</div>`);
    //alert('');
}


function loading(show){
    if(show){
        $el.find('.map').append('<div class="lds-ring"><div></div><div></div><div></div><div></div></div>');
    } else {
        $el.find('.lds-ring').remove();
    }
}

        });